import {
  useGetWithRefetch,
  UseGetWithRefreshOptions,
} from '../../../hooks/useFetchEndPoint';
import { FullGuide } from './api/types';

export const useGetGuide = (pk: string, opts?: UseGetWithRefreshOptions) => {
  return useGetWithRefetch<FullGuide>(`/api/v1/syllabus/guides/${pk}/`, opts);
};
